import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=57f2deb6&scoped=true"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=57f2deb6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f2deb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f2deb6')) {
      api.createRecord('57f2deb6', component.options)
    } else {
      api.reload('57f2deb6', component.options)
    }
    module.hot.accept("./ItemDetail.vue?vue&type=template&id=57f2deb6&scoped=true", function () {
      api.rerender('57f2deb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/item/ItemDetail.vue"
export default component.exports